import { render } from "./NoilePraguri.vue?vue&type=template&id=3cfb816e"
import script from "./NoilePraguri.vue?vue&type=script&lang=js"
export * from "./NoilePraguri.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__